import type {
  RoutineDifficultyOptionsDTO,
  RoutineDifficultyOptions,
  RoutineCharacteristicsDTO,
  RoutineCharacteristics,
  RoutineDifficultyDTO,
  RoutineDifficulty,
} from "@akina/domain";
import { type DomainMapper } from "./";

export const routineDifficultyOptionsMapper: DomainMapper<RoutineDifficultyOptions, RoutineDifficultyOptionsDTO> = {
  toDomain: (dto: RoutineDifficultyOptionsDTO): RoutineDifficultyOptions => ({
    currentRoutineTemplateKey: dto.current_routine_template_key,
    currentRoutineDifficulty: dto.current_routine_difficulty,
    adaptedRoutineDifficulty: dto.adapted_routine_difficulty,
    currentRoutineIntensity: dto.current_routine_intensity,
    adaptedRoutineIntensity: dto.adapted_routine_intensity,
    routineDifficultyHard: routineDifficultyMapper.toDomain(dto.routine_difficulty_hard),
    routineDifficultyMedium: routineDifficultyMapper.toDomain(dto.routine_difficulty_medium),
    routineDifficultyEasy: routineDifficultyMapper.toDomain(dto.routine_difficulty_easy),
  }),
};

const routineDifficultyMapper = {
  toDomain: (dto: RoutineDifficultyDTO | undefined): RoutineDifficulty | undefined =>
    dto
      ? {
          difficultyLevel: dto.difficulty_level,
          exerciseTemplateKey: dto.exercise_template_key,
          routineTemplateKey: dto.routine_template_key,
          routineCharacteristics: routineDifficultyCharacteristicsMapper.toDomain(dto.routine_characteristics),
        }
      : undefined,
  toDTO: (domain: RoutineDifficulty | undefined): RoutineDifficultyDTO | undefined =>
    domain
      ? {
          difficulty_level: domain.difficultyLevel,
          exercise_template_key: domain.exerciseTemplateKey,
          routine_template_key: domain.routineTemplateKey,
          routine_characteristics: routineDifficultyCharacteristicsMapper.toDTO(domain.routineCharacteristics),
        }
      : undefined,
};

const routineDifficultyCharacteristicsMapper = {
  toDomain: (dto: RoutineCharacteristicsDTO | undefined): RoutineCharacteristics | undefined =>
    dto
      ? {
          nSets: dto.n_sets,
          nRepetitions: dto.n_repetitions,
          holdDurationInS: dto.hold_duration_in_s,
        }
      : undefined,
  toDTO: (domain: RoutineCharacteristics | undefined): RoutineCharacteristicsDTO | undefined =>
    domain
      ? {
          n_sets: domain.nSets,
          n_repetitions: domain.nRepetitions,
          hold_duration_in_s: domain.holdDurationInS,
        }
      : undefined,
};
